import { Box, Button, Typography } from "@mui/material";
import React from "react";
import Logo from "../assets/sjlogo.png";
import { Link, useLocation } from "react-router-dom";

const Sidebar = ({ menuItems }) => {
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path || location.pathname === `/dashboard/${path}`;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FEDDDD",
        p: 2,
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          display: "flex",
          //   justifyContent: "center",
          //   alignItems: "center",
          ml: 4,
          mb: 4,
        }}
      >
        <Box component="img" src={Logo} alt="Logo" width="60%" loading="lazy" />
      </Box>

      {/* Menu Links */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          flexGrow: 1,
        }}
      >
        {menuItems
          .filter((item) => item.label !== "Logout") // Omit Logout here
          .map((item, index) => (
            <Box
              key={index}
              component={Link}
              to={item.link}
              sx={{
                textDecoration: "none",
                color: isActive(item.link) ? "#fff" : "#800001",
                backgroundColor: isActive(item.link)
                  ? "#800001"
                  : "transparent",
                padding: "10px 10px",
                borderRadius: "5px",
                fontFamily: "Poppins",
                fontSize: "18px",
                fontWeight: isActive(item.link) ? "bold" : "normal",
                width: 150,
              }}
            >
              {item.label}
            </Box>
          ))}
      </Box>
      {/* Logout Button at Bottom */}

      <Box sx={{ mb: 4, mr: 4 }}>
        <Button
          fullWidth
          sx={{
            backgroundColor: "#800001",
            color: "#fff",
            borderRadius: "5px",
          }}
          onClick={() => {
            localStorage.clear();
            window.location.href = "/";
          }}
        >
          <Typography
            sx={{ padding: "5px 0", textAlign: "center", width: "100%" }}
          >
            Logout
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default Sidebar;
